<template>
    <div class="top_con">
       <el-form :inline="true" :model="formInline" class="demo-form-inline" label-width="88px">
           <el-row :gutter="8" >
                <el-col :span="6">
                    <el-form-item label="时间类型">
                        <el-select v-model="formInline.type" placeholder="请选择" @change="edit_time">
                            <el-option label="月度统计" value="1"></el-option>
                            <el-option label="季度统计" value="2"></el-option>
                            <el-option label="年度统计" value="3"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="10">
                    <el-form-item label="具体时间">
                        <el-date-picker  v-model="formInline.time1" type="month"  placeholder="选择月" v-if="formInline.type==1" key="month" value-format="yyyy-MM"  @change="edit_times"> </el-date-picker>
                        <el-date-picker  v-model="formInline.time2" type="monthrange" key="monthrange" v-if="formInline.type==2" range-separator="至" start-placeholder="开始月份"  @change="edit_times" value-format="yyyy-MM" end-placeholder="结束月份" placeholder="选择季度"> </el-date-picker>
                        <el-date-picker  v-model="formInline.time3" type="year"  placeholder="选择年" key="year" v-if="formInline.type==3"  @change="edit_times" value-format="yyyy"> </el-date-picker>
                        <!-- <el-input v-model="formInline.prodName" placeholder="请输入" ></el-input> -->
                    </el-form-item>
                </el-col>
                <div style="float:right;">
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">查询</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="info" @click="clearS">重置</el-button>
                    </el-form-item>
                </div>
            </el-row>
        </el-form>
        <el-table  ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange" :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}" max-height="580px">
            <el-table-column  prop="paiming"  label="排名"></el-table-column>
            <el-table-column  prop="num"  label="点赞数"></el-table-column>
            <el-table-column  prop="mid"  label="名单ID"></el-table-column>
            <el-table-column prop="gangwei"  label="岗位"></el-table-column>
            <el-table-column prop="name"  label="姓名" ></el-table-column>
            <el-table-column prop="zhiwei"  label="地点" ></el-table-column>
            <el-table-column prop="num"  label="上榜人照片" >
               <template slot-scope="scope">
                    <el-image  style="width:40px;height:30px;margin:0 auto;" :src="scope.row.img" :preview-src-list="scope.row.imgs"></el-image>
                 </template>
            </el-table-column>
            <el-table-column prop="zcost"  label="作品链接" >
                <template slot-scope="scope">
                    <el-link type="primary" @click="look(1,scope.row)">查看</el-link>
                </template>
            </el-table-column>
            <el-table-column prop="dcost"  label="推荐理由" >
                <template slot-scope="scope">
                <el-link type="primary" @click="look(2,scope.row)">查看</el-link>
                </template>
            </el-table-column>
            <el-table-column prop="sprice"  label="评审">
                <template slot-scope="scope">
                <el-link type="primary" @click="look(3,scope.row)">查看</el-link>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination  background layout="prev, pager, next"  :pager-count="5" :page-size="value" :total='total' @current-change="handleCurrentChange"></el-pagination>
        <div>
            <el-dialog :title="zp_tit" :visible.sync="dialogFormVisible" width="36%">
                <el-input v-model="cknum" :disabled="true" v-if="tit_type==1"></el-input>
                <div class="wenzi" v-else-if="tit_type==2" v-html="jianjie"></div>
                <div class="wenzi2" v-else-if="tit_type==3">
                    <el-table  ref="multipleTable" :data="ps.list" tooltip-effect="dark" style="width: 100%" :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}" max-height="300px">
                        <el-table-column prop="hangye"  label="沟通能力"></el-table-column>
                        <el-table-column prop="xingjiabi" label="创意能力"></el-table-column>
                        <el-table-column prop="koucai" label="项目投入度"></el-table-column>
                        <el-table-column prop="zuopin"  label="时间观念" ></el-table-column>
                        <el-table-column prop="qita"  label="制作配合度" ></el-table-column>
                        <el-table-column prop="avg"  label="平均分" ></el-table-column>
                        <el-table-column prop="username"  label="评审人"></el-table-column>
                    </el-table>
                    <p style="padding-left:30px;">评分结果：{{ps.avg}}</p>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import {getDZList,getList_ps} from '@/utils/api'
export default {
    data(){
        return{
            houseLis:[],
            formInline: {
                type:'请选择',
                time:'',
                time1:'',
                time2:'',
                time3:''
            },
            roleid:'',
            dialogFormVisible:false,
            chuKu:false,
            jianjie:'',
             ps:{},
            formLabelWidth: '120px',
            value:10,
            total:10,
            pageNum:1,
            multipleSelection:[],
            tableData: [],
            fileList: [],
            ckid:'',
            cknum:'',
            user:{},
             zp_tit:"作品链接",
            tit_type:0,
        }
    },
    methods:{
        edit_time(val){
            console.log(val)
            this.formInline.type=val
        },
        edit_times(val){
            this.formInline.time=val;
        },
        handleCurrentChange(val){
            this.pageNum=val;
            let param ={
                numPerPage:this.value,
                pageNum:val,
                formInline:this.formInline
            }
            getDZList(param).then(res=>{
                this.total=res.total;
                this.tableData=res.list
            });
        },
        onSubmit(){
            let param ={
                numPerPage:this.value,
                pageNum:'1',
                formInline:this.formInline
            }
            getDZList(param).then(res=>{
                this.total=res.total;
                this.tableData=res.list;
            });
        },
        clearS(){
            this.formInline={}
            getDZList().then(res=>{
                this.total=res.total;
                this.tableData=res.list;
            });
        },
        look(idx,row){
            this.dialogFormVisible=true
            if(idx==1){
                this.zp_tit="作品链接";
                this.tit_type=1;
                this.cknum=row.link
            }else if(idx==2){
                this.zp_tit="推荐理由";
                this.tit_type=2;
                this.jianjie=row.intro
            }else if(idx==3){
                this.zp_tit="评审";
                this.tit_type=3;
                getList_ps({id:row.id}).then(res=>{
                   this.ps=res;
                })
            }
        },
        handleSelectionChange(val){
            this.multipleSelection = val;
        },
    },
    mounted(){
        this.user=JSON.parse(localStorage.getItem('userInfo'))
        getDZList().then(res=>{
            this.total=res.total;
            this.tableData=res.list;
        });
    }
}

</script>
<style scoped>
    .top_con{
        width:100%;
        height:auto;
        padding:20px;
        box-sizing:border-box;
    }
    .el-form-item{
        vertical-align:middle;
        margin-right:20px;
    }
    .el-input{
        /* width:193px; */
        margin-right:10px;
    }
    .el-pagination {
        text-align: right;
        margin-top: 20px;
    }
    .edit_width .el-upload-list{
        width:260px;
    }
      .el-image{
        margin-right:30px;
    }
    .wenzi{
        width:100%;
        height:100px;
        border:2px solid #e5e5e5;
    }
    table{
        margin:0 auto;
        width:100%;
        margin: 0;
    }
    table,table tr td {
            border: 1px solid #DEDEDE;
            margin: 0;
            color: #000000;
            padding: 10px 10px;
            box-sizing:border-box;
            font-size: 14px;
            font-weight: 400;
			font-family: Microsoft YaHei;
            border-collapse: collapse;
            text-align:center;
        }
</style>



// WEBPACK FOOTER //
// src/components/QueryPricing.vue